var map = {
	"./About.vue": [
		2807,
		807
	],
	"./Admin.vue": [
		9012,
		12
	],
	"./Dashboard.vue": [
		4981,
		573
	],
	"./Example.vue": [
		9972,
		972
	],
	"./HelloWorld.vue": [
		8567,
		567
	],
	"./Home.vue": [
		6368,
		146
	],
	"./Loading.vue": [
		695,
		695
	],
	"./Login.vue": [
		2921,
		921
	],
	"./Logout.vue": [
		4068,
		68
	],
	"./PhraseList.vue": [
		1056,
		56
	],
	"./PhraseListItem.vue": [
		4421,
		421
	],
	"./SearchResults.vue": [
		2502,
		502
	],
	"./SimilarList.vue": [
		9098,
		98
	],
	"./SimpleSearch.vue": [
		1880,
		880
	],
	"./Unit.vue": [
		1113,
		113,
		427
	],
	"./UnitList.vue": [
		1134,
		113,
		837
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3457;
module.exports = webpackAsyncContext;